"use client";

import { useTranslations } from "next-intl";
import Image from 'next/image';
import { useRouter } from "next-nprogress-bar";
import Button from "@apg.gg/core/lib/Button";
import { useParams } from "next/navigation";

export default function HOKSectionClient() {
  const router = useRouter();
  const { locale } = useParams();
  const t = useTranslations('Home');

  return (
    <section className="w-full py-12 md:py-24 lg:py-32">
      <div className="container grid items-center gap-6 px-4 md:px-6 lg:grid-cols-2 lg:gap-10">
        <Image
          src="/assets/resources/bg-hok-draft.png"
          width="600"
          height="400"
          alt="Honor of Kings"
          className="mx-auto rounded-xl object-cover"
        />
        <div className="space-y-4">
          <div className="inline-block rounded-2xl bg-blue-400 px-3 py-1 text-sm">Honor of Kings</div>
          <h2 className="text-display-sm">
            {t("take-your-broadcasts-to-the-next-level")}
          </h2>
          <p className="max-w-[600px] font-source-sans-pro text-muted-foreground md:text-ti/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
            {t("our-tools-for-honor-of-kings-allow-you-to-enhance-the-visual-quality-of-your-streams-whether-in-tournaments-showmatch-or-simply-sharing-with-your-community")}
          </p>
          <div>
            <Button
              type="primary"
              className="text-title-sm"
              onClick={() => {
                router.push(`/${locale}/honor-of-kings`);
              }}
            >
              {t("discover-our-tools")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}